/**
 * JavaScript Utility - json/decode
 * @author 서명환 <mhseo@ulalalab.com>
 */
function decode(json, isSafe = false) {
  try {
    return JSON.parse(json);
  } catch {
    if (isSafe) {
      return null;
    }

    throw new Error(
      `[utils.json.decode] You're trying to decode an invalid JSON String: ${json}`
    );
  }
}

export default decode;
